import { h } from '@stencil/core';

const Icon = ({ width = '25', height = '22' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 22">
      <path d="m12.28 9.428 9.667 9.429H2.612l9.668-9.429Z" fill="currentColor" />
      <path
        d="m15.044 10.234-.354.351.35.355 6.386 6.48.85.862.006-1.21.072-12.898.006-1.21-.858.853-6.458 6.417Zm-5.262-.016.406.367-.402.371-7.018 6.483-.834.77-.006-1.135-.071-12.897-.006-1.134.841.761 7.09 6.414Z"
        stroke="#fff"
        fill="currentColor"
      />
      <path d="m12.629 12.93-.35.34-.348-.34L2.263 3.5l-.88-.857h21.794l-.88.858-9.668 9.428Z" stroke="#fff" fill="currentColor" />
    </svg>
  );
};

export default Icon;
